/** Banner shown on an order whose invoice expired (unpaid 7+ days). Staff can reactivate it from here. */
import React, { useState } from 'react';
import { Hourglass, RotateCcw } from 'lucide-react';
import { toast } from 'sonner';
import API_URL from '@/config/api';
import { formatApiError } from '@/utils/apiError';

export function InvoiceExpiredNotice({ order, product, isStaff, onReactivated }) {
  const [busy, setBusy] = useState(false);
  if (!order?.invoice_expired_at || order.status !== 'invoiced') return null;
  const reactivate = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${API_URL}/api/staff/orders/${product}/${order.id}/reactivate-invoice`, { method: 'POST', credentials: 'include' });
      if (!res.ok) throw new Error(formatApiError(await res.json().catch(() => ({}))) || 'Failed');
      toast.success('Invoice reactivated — back on the Invoice Board');
      onReactivated?.();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900" data-testid="invoice-expired-notice">
      <Hourglass className="w-4 h-4 shrink-0" />
      <div className="flex-1 min-w-[200px]">
        <strong>This invoice has expired</strong> — it wasn't paid within 7 days of being raised ({new Date(order.invoice_expired_at).toLocaleDateString('en-GB')}).
        {isStaff ? ' It has left the Invoice Board; reactivate it if the customer still wants to go ahead.' : ' Prices may have changed — please contact Ox Resin for an up-to-date invoice before paying.'}
      </div>
      {isStaff && <button type="button" onClick={reactivate} disabled={busy} className="inline-flex items-center gap-1 rounded-md border border-amber-400 bg-white px-2.5 py-1 text-xs font-bold text-amber-900 hover:bg-amber-100 disabled:opacity-60" data-testid="invoice-expired-reactivate"><RotateCcw className="w-3.5 h-3.5" /> {busy ? 'Working…' : 'Reactivate invoice'}</button>}
    </div>
  );
}
